import { IRequest } from '@r1-frontend/shared/types/IRequest';

interface IGetTvPacketList {
    packetIds?: number[],
    notNullPrice?: number,
    active?: number,
    with?: string,
}

/*
* Список пакетов каналов в разрезе провайдеров
* https://master.api-epg.sandbox.d2c.r-one.io/docs/#/v1/PacketController_getPacketsByProviderId
*/

export const getPackageChannels = (providerId: number, params: IGetTvPacketList): IRequest =>({
    uri: `/api/v1/${providerId}/packets`,
    method: 'GET',
    queryParams: { ...params },
    headers: {
        providerId: `${providerId}`,
    },
});
